<template>
  <div class="poster_box_inner">
    <p v-if="imageClass !== 'trailer'" :class="imageClass">
      <img :src="imageLink">
    </p>
    <span v-if="image && imageClass !== 'trailer'" :class="textClass">
      {{ image.width }} x {{ image.height }} px
      <br>
      {{ Math.round(image.size / 1000) }} kB
    </span>
    <p v-if="imageClass === 'trailer'" :class="imageClass">
      <a
          :href="youtubeLink"
          v-translate
          target="_blank"
      >
        Přehrát trailer
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'image-item',
  props: {
    image: {
      type: Object,
      default: null
    },
    imageClass: {
      type: String,
      default: ''
    },
    textClass: {
      type: String,
      default: ''
    },
    youtubeLink: {
      type: String,
      default: ''
    }
  },
  computed: {
    imageLink() {
      const isLink = this.image && this.image.imageLink
      if (isLink) {
        return this.image.imageLink
      }
      return null
    }
  }
}
</script>
